import { useMemo } from "react";
import { externalSiteUrls } from "settings";
import { useIdentityContext } from "contexts/identity/IdentityContext";
import parseJwt from "utils/parseJwt";

interface IJwtPayload {
    country?: string;
    [key: string]: unknown;
}

export interface IFooterLink {
    label: string;
    url: string;
}

const useFooterLinks = () => {
    const { state } = useIdentityContext();
    const accessToken = state.jwtTokens.tokens.accessToken;

    const isUS = useMemo(() => {
        if (!accessToken) return true;
        const payload = parseJwt<IJwtPayload>(accessToken);
        if (!payload?.country) return true;
        return payload.country === "US";
    }, [accessToken]);

    const links = useMemo<IFooterLink[]>(() => {
        const allLinks: IFooterLink[] = [
            { label: "Legal & Privacy", url: externalSiteUrls.footer.legal },
            { label: "User Agreement", url: externalSiteUrls.footer.termsAndConditions },
            { label: "Privacy & Cookie Policy", url: externalSiteUrls.footer.privacyPolicy },
            { label: "Online Service Updates", url: externalSiteUrls.footer.serviceUpdates },
            { label: "Security", url: externalSiteUrls.footer.security },
        ];

        if (isUS) {
            allLinks.push({ label: "Notice at Collection", url: externalSiteUrls.footer.noticeAtCollection });
        }

        return allLinks;
    }, [isUS]);

    return { links, isUS };
};

export default useFooterLinks;
